<template>
  <div class="product-details-content-setup-step-03">
    <div class="mb-5">
      <step-title
        title="Configurar certificado"
        description="Configure o certificado do seu curso."
        icon="fa fa-award"
      />
    </div>

    <b-form-checkbox
      switch
      v-model="form.certificate_enabled"
      class="pt-6"
      :class="{ 'text-primary': form.certificate_enabled }"
    >
      Certificado {{ form.certificate_enabled ? "ativado" : "desativado" }}
    </b-form-checkbox>
    <small class="text-secondary">
      Você pode desativar e ativar seu certificado a qualquer momento, sem
      perder os dados salvos.
    </small>

    <div class="pt-6">
      <div>
        Porcentagem de conclusão do curso para emissão do certificado
      </div>
      <small class="text-secondary">
        Decida qual porcentagem de conteúdo e de avaliação deverão ser
        concluídos para liberação de certificado na sua área de membros.
        <!-- Decida qual porcentagem de conteúdo deverá ser concluído para liberação
        de certificado na sua área de membros. -->
      </small>
    </div>

    <div class="mt-6 pb-3">
      <div>
        Conteúdo
      </div>
      <small class="text-secondary">
        Selecione a porcentagem
      </small>
    </div>
    <b-form-input
      class="col-lg-8"
      id="conclusion-range"
      :min="1"
      :max="100"
      type="range"
      v-model="form.minimum_content_progress"
    />
    <small>{{ form.minimum_content_progress || 0 }} %</small>

    <div class="d-flex mt-5">
      <div class="mr-3">
        <i class="icon-exclamation-solid text-danger small" />
      </div>
      <small class="text-secondary w-75">
        Recomendamos a configuração de 100% para conteúdo. Assim, seu aluno terá
        que concluir todas as aulas para garantir a liberação do certificado
      </small>
    </div>

    <b-form-checkbox
      switch
      v-model="rating_enabled"
      class="pt-6"
      :class="{ 'text-primary': rating_enabled }"
    >
      Incluir avaliações para obter certificado
    </b-form-checkbox>

    <div v-if="rating_enabled">
      <div class="mt-6 pb-3">
        <div>
          Avaliações
        </div>
        <small class="text-secondary">
          Selecione a porcentagem
        </small>
      </div>
      <b-form-input
        class="col-lg-8"
        id="conclusion-range"
        :min="1"
        :max="100"
        type="range"
        v-model="form.minimum_quiz_progress"
      />

      <small>{{ form.minimum_quiz_progress || 0 }} %</small>
      <div class="d-flex mt-5">
        <div class="mr-3">
          <i class="icon-exclamation-solid text-danger small" />
        </div>
        <small class="text-secondary w-75">
          Recomendamos a configuração de 100% para avaliações. Assim, seu aluno
          terá que concluir todas as avaliações para garantir a liberação do
          certificado
        </small>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    rating_enabled: {
      get() {
        return !!this.form.minimum_quiz_progress;
      },
      set(v) {
        this.form.minimum_quiz_progress = v ? 100 : 0;
        return v;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.product-details-content-setup-step-03 {
  input[type="range"] {
    display: block;
  }
}
</style>
